// Nama File: SourceOfBookingCharts_Highcharts.tsx

import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import useReservationStatistic from '../../../services/booking-chart/hooks/useReservationStatistic';
import useRevenueStatistic from '../../../services/booking-chart/hooks/useRevenueStatistic';
import PieChartSkeleton from '../../pms-report/components/PieChartSkeleton';
// Ganti impor ke komponen Highcharts yang baru
import HighchartsPie3DComponent from './HighchartsPie3DComponent';

// Interface untuk data yang akan dirender oleh chart
interface PieChartData {
    title: string;
    data: {
        name: string;
        value: number;
        color?: string | null;
    }[];
}

// Interface untuk props komponen
interface SourceOfBookingChartsProps {
    startDate: string;
    endDate: string;
}

const SourceOfBookingCharts_Highcharts: React.FC<SourceOfBookingChartsProps> = ({ startDate, endDate }) => {
    const [pieChartsData, setPieChartsData] = useState<PieChartData[]>([]);

    const filters = {
        start_date: startDate,
        end_date: endDate,
    };

    const { data: reservationData, isFetching: isFetchingReservations } = useReservationStatistic({ filters });
    const { data: revenueData, isFetching: isFetchingRevenue } = useRevenueStatistic({ filters });

    useEffect(() => {
        if (reservationData?.data && revenueData?.data) {
            const payloadPieCharts: PieChartData[] = [
                {
                    title: "Number Of Reservations By Source",
                    data: reservationData.data.map(item => ({
                        name: item.name,
                        value: item.total,
                        color: item.color,
                    })),
                },
                {
                    title: "Total Revenue By Source",
                    data: revenueData.data.map(item => ({
                        name: item.name,
                        value: item.revenue,
                        color: item.color,
                    })),
                },
            ];
            setPieChartsData(payloadPieCharts);
        }
    }, [reservationData, revenueData]);

    const isLoading = isFetchingReservations || isFetchingRevenue;

    return (
        <div className="charts-section mt-4">
            <Row className="gy-4">
                {isLoading && (
                    <>
                        {Array.from({ length: 2 }).map((_, index) => (
                            <Col key={index} md={6}>
                                <PieChartSkeleton />
                            </Col>
                        ))}
                    </>
                )}
                {!isLoading && pieChartsData.length > 0 && pieChartsData.map((chart, index) => (
                    <Col key={index} md={6}>
                        {/* Gunakan komponen Highcharts di sini */}
                        <HighchartsPie3DComponent title={chart.title} data={chart.data} />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SourceOfBookingCharts_Highcharts;